import { createMessenger } from '@userlike/messenger';

declare global {
    interface Window {
        selectedCookies: { [key: string]: boolean },
    }
}

declare const cookiesVar: {
    userlike: string,
};

/**
 * An event "axeptio_ready" is ditached when Axeptio is ready
 * "window.selectedCookies" contains all cookies defined in axeptio with the user choice
 * 
 * @property {Object} cookiesList Object containing all cookies informations
 */
export default class Cookies {
    cookiesList: { [key: string]: { id: string } } = {};

    constructor() {
        window.selectedCookies = {};
        this.cookiesList = {};

        // Define all scripts managed by axeptio
        if (typeof cookiesVar !== 'undefined') {
            if (typeof cookiesVar.userlike !== 'undefined' && cookiesVar.userlike !== '') {
                this.cookiesList.userlike = {
                    id: cookiesVar.userlike,
                };

                window.selectedCookies.userlike = false;
            }

            this.waitForAxeptio();
        }
    }

    /**
     * Waiting for global variable _axcb
     * 
     * @return {void}
     */
    waitForAxeptio() : void {
        if (typeof _axcb !== 'undefined') {
            this.applyCookies();

            document.dispatchEvent(new CustomEvent('axeptio_ready'));
        } else {
            setTimeout(() => {
                this.waitForAxeptio();
            }, 250);
        }
    }

    /**
     * Load scripts managed by Axeptio
     * 
     * @return {void}
     */
    applyCookies() : void {
        _axcb.push(axeptio => {
            axeptio.on('cookies:complete', choices => {
                Object.keys(choices).forEach(key => {
                    const attr = this.cookiesList[key];

                    if (typeof attr !== 'undefined') {
                        if (choices[key] === true) {
                            if (attr.id) {
                                const userlike = createApi(attr.id);

                                userlike.then(messenger => messenger.mount());

                                const startChat = () => {
                                    userlike.then(m => m.maximize());
                                };
                                
                                document.querySelectorAll<HTMLElement>('.js-show-userlike').forEach($btn => {
                                    $btn.addEventListener('click', () => startChat());
                                });
                            }

                            window.selectedCookies[key] = true;
                        } else {
                            window.selectedCookies[key] = false;
                        }
                    } else {
                        window.selectedCookies[key] = choices[key];
                    }
                });
            });
        });
    }
}

async function createApi($widgetKey: string) {
    const result = await createMessenger({
        version: 1,
        widgetKey: $widgetKey,
    });
    const { api } = result.value;
    return api;
}
